<template>
  <!--
      	作者：luo
      	时间：2020-09-15
      	描述：插件中心-文章
      -->
  <div class="user">
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName">
        <el-tab-pane label="业务员列表" name="article">
          <Article v-if="activeName=='article'"></Article>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
  import statisticalApi from '@/api/statistical.js';
  import Article from './detail/Index.vue';

  export default {
    components: {
      Article,

    },
    data() {
      return {
        activeName: 'article',
        /*是否加载完成*/
        loading: true,
      }
    },
    created() {


    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/plus/statistical/index.vue